import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Box, Button, Grid2 } from '@mui/material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { BOX_SHADOW } from '../../shared/constants';
import { useEventDetail } from '../../assets/api/useGetApi';
import { useParams } from 'react-router-dom';
import { TextSkeleton } from '../../shared/utils/SkeletonCom';
import { BulletList } from '../Courses/UiUxDevelopement';
import { CutCurrency } from '../../shared/utils/CutCurrency';

const EventSubscribeCard = () => {
    const { id } = useParams();
    const { data: eventDetail, isLoading } = useEventDetail(id);

    return (

        <Grid2 container spacing={5}>
            <Grid2 children size={{ xs: 12, lg: 8 }}
                sx={{
                    maxHeight: { xs: "auto", lg: "80vh" },
                    overflowY: { xs: "auto", lg: "scroll" },
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": {
                        display: "none",
                    },
                }}
            >

                {isLoading && <TextSkeleton line={1} width={"100%"} />}
                {!isLoading && <Typography variant='h1'>
                    {eventDetail?.data?.event_name}
                </Typography>}
                {eventDetail?.data?.event_description && (
                    <Box my={5}>
                        {isLoading && <TextSkeleton line={10} width={"100%"} />}
                        {!isLoading && <BulletList title={"Description"} items={eventDetail?.data?.event_description} />}
                    </Box>
                )}
            </Grid2>

            <Grid2 children size={{ xs: 12, lg: 4 }}>
                <Card
                    sx={{
                        boxShadow: BOX_SHADOW,
                        border: "1px solid #F0F0F0",
                        p: "32px 22px",
                        borderRadius: "40px"
                    }}>

                    <CardContent>
                        <Box sx={{}}>
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: 1,
                                    alignItems: "center"
                                }}
                            >
                                {isLoading && <TextSkeleton width={120} line={1} />}
                                {!isLoading && <>
                                    {eventDetail?.data?.event_price[0]?.early_bird_discount ? (
                                        <CutCurrency
                                            fontSize={"20px"}
                                            iconSize={"22px"}
                                            value={eventDetail?.data?.event_price[0]?.original_price}
                                        />
                                    ) : null}
                                    <CurrencyRupeeIcon sx={{ color: "red.main", fontSize: "30px" }} />
                                    <Typography variant='h2' fontWeight={500}>{eventDetail?.data?.event_price[0]?.price_with_discount ?? 0}</Typography>
                                </>
                                }

                            </Box>
                            {eventDetail?.data?.event_price[0]?.early_bird_discount ? (
                                <Typography variant='body2'>Discount available till {eventDetail?.data?.event_price[0]?.early_bird_discount_date} {""} {eventDetail?.data?.event_price[0]?.early_bird_discount_time}</Typography>
                            ) : null}



                        </Box>

                        <Box
                            sx={{
                                border: "0.5px solid #000000",
                                borderRadius: "40px",
                                my: 4
                            }}
                        >
                            <Grid2 container>
                                <Grid2 children size={6} sx={{ borderRight: "0.5px solid #000000", p: 3 }}>
                                    <Typography variant="body2" >Start Date</Typography>
                                    {isLoading && <TextSkeleton width={100} line={1} />}
                                    {!isLoading &&
                                        <Typography variant="body2" fontSize={"12px"}>{eventDetail?.data?.start_date}</Typography>
                                    }

                                </Grid2>
                                <Grid2 children size={6} sx={{ p: 3 }}>
                                    <Typography variant="body2">End Date</Typography>

                                    {isLoading && <TextSkeleton width={100} line={1} />}
                                    {!isLoading &&
                                        <Typography variant="body2" fontSize={"12px"}>{eventDetail?.data?.end_date}</Typography>
                                    }
                                </Grid2>
                            </Grid2>
                            <Box sx={{ p: 3, borderTop: "0.5px solid #000000" }}>
                                {isLoading && <TextSkeleton width={"100%"} line={3} />}
                                {!isLoading &&
                                    <> <Typography variant="body2" fontSize={"12px"} my={1}>
                                        Time : {eventDetail?.data?.start_time} - {eventDetail?.data?.end_time}
                                    </Typography>
                                        <Typography variant="body2" fontSize={"12px"} my={1}>
                                            Venue : {eventDetail?.data?.event_venue}
                                        </Typography>
                                        <Typography variant="body2" fontSize={"12px"} my={1}>
                                            Event Type : {eventDetail?.data?.event_type}
                                        </Typography>
                                        <Typography variant="body2" fontSize={"12px"} my={1} color='red.main'>
                                            Available Seat : {eventDetail?.data?.event_available_seats}
                                        </Typography>
                                    </>
                                }

                            </Box>
                        </Box>

                        <Button variant='contained' fullWidth> Subscribe</Button>
                        <Typography variant='body1' fontSize={"12px"} textAlign={"center"} color='red.main' mt={2}>
                            Do you have an account ??
                        </Typography>
                    </CardContent>
                </Card>
            </Grid2>
        </Grid2 >


    )
}

export default EventSubscribeCard